import React, {Component} from 'react';
import {Card} from "semantic-ui-react";
import {connect} from "react-redux";
import {getSelectedProperties} from "../utils/common";
import DirtyOnlySwitch from "../components/dirtyOnlySwitch";
import MaintenanceTaskCard from "../components/cleanableCards/maintenanceTaskCard";
import {cardTypes} from "../components/cleanableCards/types";

const mapStateToProps = (state, ownProps) => {
    const {properties} = state;
    const {propertyList, selectedPropertyIds} = properties;
    const selectedProperties = getSelectedProperties(propertyList, selectedPropertyIds);

    return {
        ...ownProps,
        loadingRoomsData: !!properties.loading,
        selectedProperties,
    }
};

class MaintenanceTasks extends Component {
    render() {
        const {selectedProperties} = this.props;

        return (
            <div>
                <DirtyOnlySwitch typeName={cardTypes.MAINTENANCE_TASKS}/>

                <Card.Group>
                    {selectedProperties.map(sp => {
                        const propertyName = sp.propertyName;
                        const propertyId = sp.id;

                        if (!!sp && !!sp.roomWithMaintenanceTaskDataList) {
                            return sp.roomWithMaintenanceTaskDataList.map((r, idx) =>
                                <MaintenanceTaskCard key={idx}
                                             {...r}
                                             propertyName={propertyName}
                                             propertyId={propertyId}
                                />)
                        }

                        return null;
                    })}
                </Card.Group>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MaintenanceTasks);
